import { tw } from "@careinfo/tailwind";
import { useState, useEffect, useRef } from "react";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/EndPoint";
import { toast } from "react-toastify";
import TextField from "../Reusable/TextField";
import { createPortal } from "react-dom";
const TooltipPortal = ({ children }: { children: React.ReactNode }) => {
  return createPortal(children, document.body);
};

export default TooltipPortal;

export const StatusCell = ({ row, refetch, setError }: any) => {
  const [open, setOpen] = useState(false);
  const [adminRemark, setAdminRemark] = useState("");
  const status = row.original.status;
  const applicationId = row.original.id;

  const tooltipRef = useRef<HTMLDivElement>(null);

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["leave-application"],
    navigateURL: "",
  });
  const [tooltipPosition, setTooltipPosition] = useState({
    top: 0,
    left: 0,
  });
  const updateStatus = async (newStatus: string) => {
    const url = `${APIS.LEAVE}${applicationId}/`;
    const formData = {
      status: newStatus,
      admin_remark: adminRemark,
    };

    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        refetch?.();
      }
    } catch (err: any) {
      toast.error(err?.message || "Something went wrong");
    } finally {
      setOpen(false);
      setAdminRemark("");
    }
  };

  const handleApprove = () => updateStatus("approved");
  const handleReject = () => updateStatus("rejected");

  const isDisabled =
    status === "approved" || status === "cancelled" || status === "rejected";

  const statusColor =
    status === "approved"
      ? "bg-green-500"
      : status === "cancelled" || status === "rejected"
      ? "bg-red-500"
      : "bg-yellow-500";
  const handleOpen = (e: React.MouseEvent<HTMLSpanElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();

    setTooltipPosition({
      top: rect.top + window.scrollY,
      left: rect.left - 260,
    });

    setOpen(true);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div className="relative z-1000 inline-block  ">
      <span
        className={tw`px-2 py-1 rounded text-white ${statusColor} ${
          isDisabled ? "cursor-not-allowed" : "cursor-pointer"
        }`}
        onClick={(e) => {
          if (isDisabled) return;
          e.stopPropagation();
          handleOpen(e);
        }}
      >
        {status || "Pending"}
      </span>

      {!isDisabled && open && (
        <TooltipPortal>
          <div
            ref={tooltipRef}
            style={{
              position: "fixed",
              top: tooltipPosition.top,
              left: tooltipPosition.left,
            }}
            className={tw`z-[9999] w-60 bg-white border shadow-lg rounded p-3`}
            onClick={(e) => e.stopPropagation()}
          >
            <TextField
              label="Admin Response"
              placeholder="Enter remark"
              value={adminRemark}
              register={{
                value: adminRemark,
                onChange: (e: any) => setAdminRemark(e.target.value),
              }}
            />

            <div className={tw`flex space-x-2`}>
              <button
                onClick={handleApprove}
                disabled={isPatchLoading}
                className={tw`flex-1 px-2 py-1 bg-green-500 text-white rounded hover:bg-green-600 disabled:opacity-50`}
              >
                Approve
              </button>
              <button
                onClick={handleReject}
                disabled={isPatchLoading}
                className={tw`flex-1 px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600 disabled:opacity-50`}
              >
                Reject
              </button>
            </div>
          </div>
        </TooltipPortal>
      )}
    </div>
  );
};
